export const products = [
  {
    id: 1,
    name: 'AF006 – Flat Design Radiator',
    price: 726.87,
    originalPrice: null,
    category: 'Radiators',
    image: 'https://public.readdy.ai/ai/img_res/b4a5859633c61768b4316eb0830c1984.jpg',
    status: null,
    rating: 4.8,
    reviews: 34,
    description: 'Flat Design Radiator with Horizontal Tube ø38 and Vertical Tube 68×12. Premium steel construction with excellent heat output. Ideal for modern bathrooms and living spaces.',
    sizes: ['1800x532'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF006',
    pricePerPiece: 498.18,
    costPerPiece: 76.23,
  },
  {
    id: 2,
    name: 'AF007 – Flat Design Radiator',
    price: 912.63,
    originalPrice: null,
    category: 'Radiators',
    image: 'https://readdy.ai/api/search-image?query=flat%20panel%20designer%20radiator%20horizontal%20tube%2038mm%20vertical%20tube%2068x12mm%20anthracite%20grey%20finish%20on%20clean%20white%20background%2C%20modern%20heating%20system%2C%20minimalist%20bathroom%20fixture%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20front%20view%20centered%20composition%2C%20simple%20background&width=600&height=600&seq=af007&orientation=squarish',
    status: null,
    rating: 4.7,
    reviews: 28,
    description: 'Flat Design Radiator with Horizontal Tube ø38 and Vertical Tube 68×12. High-performance steel radiator with superior heat distribution. Perfect for contemporary interiors.',
    sizes: ['1800x532'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF007',
    pricePerPiece: 625.50,
    costPerPiece: 95.71,
  },
  {
    id: 3,
    name: 'AF008 – Flat Design Radiator',
    price: 622.68,
    originalPrice: null,
    category: 'Radiators',
    image: 'https://readdy.ai/api/search-image?query=flat%20panel%20designer%20radiator%20compact%20size%20600x988mm%20white%20finish%20on%20clean%20white%20background%2C%20modern%20heating%20system%2C%20minimalist%20bathroom%20fixture%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20front%20view%20centered%20composition%2C%20simple%20background&width=600&height=600&seq=af008&orientation=squarish',
    status: null,
    rating: 4.6,
    reviews: 19,
    description: 'Flat Design Radiator with Horizontal Tube ø38 and Vertical Tube 68×12. Compact size suitable for smaller rooms. Efficient heating with a sleek flat panel design.',
    sizes: ['600x988'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF008',
    pricePerPiece: 426.78,
    costPerPiece: 65.30,
  },
  {
    id: 4,
    name: 'AF009 – Flat Design Radiator',
    price: 722.52,
    originalPrice: null,
    category: 'Radiators',
    image: 'https://readdy.ai/api/search-image?query=flat%20panel%20designer%20radiator%20600x1216mm%20tall%20white%20finish%20on%20clean%20white%20background%2C%20modern%20heating%20system%2C%20minimalist%20bathroom%20fixture%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20front%20view%20centered%20composition%2C%20simple%20background&width=600&height=600&seq=af009&orientation=squarish',
    status: null,
    rating: 4.8,
    reviews: 22,
    description: 'Flat Design Radiator with Horizontal Tube ø38 and Vertical Tube 68×12. Tall format for maximum heat output in medium-sized rooms. Premium steel build.',
    sizes: ['600x1216'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF009',
    pricePerPiece: 495.21,
    costPerPiece: 75.77,
  },
  {
    id: 5,
    name: 'AF010 – Flat Design Radiator',
    price: 632.19,
    originalPrice: null,
    category: 'Radiators',
    image: 'https://readdy.ai/api/search-image?query=flat%20panel%20designer%20radiator%20600x988mm%20sand%20black%20finish%20on%20clean%20white%20background%2C%20modern%20heating%20system%2C%20minimalist%20bathroom%20fixture%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20front%20view%20centered%20composition%2C%20simple%20background&width=600&height=600&seq=af010&orientation=squarish',
    status: null,
    rating: 4.7,
    reviews: 17,
    description: 'Flat Design Radiator with Horizontal Tube ø38 and Vertical Tube 68×12. Compact and efficient, ideal for bathrooms and hallways. Durable powder-coated finish.',
    sizes: ['600x988'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF010',
    pricePerPiece: 433.29,
    costPerPiece: 66.30,
  },
  {
    id: 6,
    name: 'AF011 – Flat Design Radiator',
    price: 760.23,
    originalPrice: null,
    category: 'Radiators',
    image: 'https://readdy.ai/api/search-image?query=flat%20panel%20designer%20radiator%20600x1216mm%20anthracite%20finish%20on%20clean%20white%20background%2C%20modern%20heating%20system%2C%20minimalist%20bathroom%20fixture%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20front%20view%20centered%20composition%2C%20simple%20background&width=600&height=600&seq=af011&orientation=squarish',
    status: null,
    rating: 4.9,
    reviews: 31,
    description: 'Flat Design Radiator with Horizontal Tube ø38 and Vertical Tube 68×12. Tall and powerful, delivers excellent warmth for larger spaces. Elegant flat panel aesthetic.',
    sizes: ['600x1216'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF011',
    pricePerPiece: 521.04,
    costPerPiece: 79.73,
  },
  {
    id: 7,
    name: 'AF012 – Horizontal Tube Radiator',
    price: 692.25,
    originalPrice: null,
    category: 'Radiators',
    image: 'https://readdy.ai/api/search-image?query=horizontal%20tube%20radiator%2032mm%20vertical%20tube%2050x25mm%20white%20finish%201800x480mm%20on%20clean%20white%20background%2C%20modern%20heating%20system%2C%20minimalist%20bathroom%20fixture%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20front%20view%20centered%20composition%2C%20simple%20background&width=600&height=600&seq=af012&orientation=squarish',
    status: null,
    rating: 4.7,
    reviews: 25,
    description: 'Horizontal Tube Radiator ø32 with Vertical Tube 50×25. Wide format radiator perfect for under-window installation. High heat output with a clean modern look.',
    sizes: ['1800x480'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF012',
    pricePerPiece: 474.45,
    costPerPiece: 72.60,
  },
  {
    id: 8,
    name: 'AF015 – Horizontal Tube Radiator',
    price: 867.78,
    originalPrice: null,
    category: 'Radiators',
    image: 'https://readdy.ai/api/search-image?query=horizontal%20tube%20radiator%2032mm%20vertical%20tube%2050x25mm%20white%20finish%201800x680mm%20on%20clean%20white%20background%2C%20modern%20heating%20system%2C%20minimalist%20bathroom%20fixture%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20front%20view%20centered%20composition%2C%20simple%20background&width=600&height=600&seq=af015&orientation=squarish',
    status: null,
    rating: 4.8,
    reviews: 20,
    description: 'Horizontal Tube Radiator ø32 with Vertical Tube 50×25. Taller version for increased heat output. Ideal for living rooms and open-plan spaces.',
    sizes: ['1800x680'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF015',
    pricePerPiece: 594.75,
    costPerPiece: 91.01,
  },
  {
    id: 9,
    name: 'AF016 – Towel Warmer',
    price: 171.99,
    originalPrice: null,
    category: 'Towel Warmers',
    image: 'https://readdy.ai/api/search-image?query=chrome%20heated%20towel%20warmer%20rail%201800x600mm%20ladder%20style%20on%20clean%20white%20background%2C%20modern%20bathroom%20towel%20radiator%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20sleek%20contemporary%20design%2C%20simple%20background&width=600&height=600&seq=af016&orientation=squarish',
    status: null,
    rating: 4.6,
    reviews: 42,
    description: 'Towel Warmer ø22+30×40. Keeps towels warm and dry while efficiently heating your bathroom. Stylish ladder design with durable finish.',
    sizes: ['1800x600'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF016',
    pricePerPiece: 117.87,
    costPerPiece: 18.04,
  },
  {
    id: 10,
    name: 'AF017 – Towel Warmer',
    price: 180.21,
    originalPrice: null,
    category: 'Towel Warmers',
    image: 'https://readdy.ai/api/search-image?query=anthracite%20heated%20towel%20warmer%20rail%201800x600mm%20ladder%20style%20on%20clean%20white%20background%2C%20modern%20bathroom%20towel%20radiator%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20sleek%20contemporary%20design%2C%20simple%20background&width=600&height=600&seq=af017&orientation=squarish',
    status: null,
    rating: 4.7,
    reviews: 38,
    description: 'Towel Warmer ø22+30×40. Premium towel radiator with excellent heat retention. Perfect for bathrooms requiring both warmth and towel drying functionality.',
    sizes: ['1800x600'],
    material: 'Steel',
    inStock: true,
    stock: 10,
    itemNo: 'AF017',
    pricePerPiece: 123.51,
    costPerPiece: 18.90,
  },
  {
    id: 11,
    name: 'AF001 – H Valve White',
    price: 102.96,
    originalPrice: null,
    category: 'Valves',
    image: 'https://readdy.ai/api/search-image?query=H%20valve%2016mm%20G1%2F2%20connection%20white%20finish%20on%20clean%20white%20background%2C%20radiator%20valve%20fitting%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20simple%20background%2C%20plumbing%20accessory&width=600&height=600&seq=af001&orientation=squarish',
    status: null,
    rating: 4.5,
    reviews: 61,
    description: 'H Valve 16MM × G1/2 Connection – White. Essential radiator valve for precise flow control. Easy installation with standard G1/2 connection.',
    sizes: ['Standard'],
    material: 'Brass',
    inStock: true,
    stock: 50,
    itemNo: 'AF001',
    pricePerPiece: 70.56,
    costPerPiece: 10.80,
  },
  {
    id: 12,
    name: 'AF002 – H Valve Sand Black',
    price: 102.96,
    originalPrice: null,
    category: 'Valves',
    image: 'https://readdy.ai/api/search-image?query=H%20valve%2016mm%20G1%2F2%20connection%20sand%20black%20finish%20on%20clean%20white%20background%2C%20radiator%20valve%20fitting%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20simple%20background%2C%20plumbing%20accessory&width=600&height=600&seq=af002&orientation=squarish',
    status: null,
    rating: 4.5,
    reviews: 47,
    description: 'H Valve 16MM × G1/2 Connection – Sand Black. Stylish sand black finish to complement modern radiators. Standard G1/2 connection for easy fitting.',
    sizes: ['Standard'],
    material: 'Brass',
    inStock: true,
    stock: 50,
    itemNo: 'AF002',
    pricePerPiece: 70.56,
    costPerPiece: 10.80,
  },
  {
    id: 13,
    name: 'AF003 – H Valve Anthracite',
    price: 102.96,
    originalPrice: null,
    category: 'Valves',
    image: 'https://readdy.ai/api/search-image?query=H%20valve%2016mm%20G1%2F2%20connection%20anthracite%20dark%20grey%20finish%20on%20clean%20white%20background%2C%20radiator%20valve%20fitting%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20simple%20background%2C%20plumbing%20accessory&width=600&height=600&seq=af003&orientation=squarish',
    status: null,
    rating: 4.6,
    reviews: 53,
    description: 'H Valve 16MM × G1/2 Connection – Anthracite. Dark anthracite finish for a premium look. Compatible with all standard radiator systems.',
    sizes: ['Standard'],
    material: 'Brass',
    inStock: true,
    stock: 50,
    itemNo: 'AF003',
    pricePerPiece: 70.56,
    costPerPiece: 10.80,
  },
  {
    id: 14,
    name: 'AF-Ushorisontal – Towel Radiator Double Layer',
    price: 4.38,
    originalPrice: null,
    category: 'Towel Warmers',
    image: 'https://readdy.ai/api/search-image?query=double%20layer%20towel%20radiator%201596x600mm%20anthracite%20finish%20on%20clean%20white%20background%2C%20modern%20bathroom%20towel%20warmer%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20sleek%20contemporary%20design%2C%20simple%20background&width=600&height=600&seq=afush&orientation=squarish',
    status: null,
    rating: 4.8,
    reviews: 14,
    description: 'Towel Radiator 1596×600 Double Layers – Anthracite. Double-layer design for maximum towel capacity and heat output. Premium anthracite finish.',
    sizes: ['1596x600'],
    material: 'Steel',
    inStock: true,
    stock: 5,
    itemNo: 'AF-Ushorisontal',
    pricePerPiece: 3.00,
    costPerPiece: 0.46,
  },
  {
    id: 15,
    name: 'AF-SP – Towel Radiator Anthracite',
    price: 4.38,
    originalPrice: null,
    category: 'Towel Warmers',
    image: 'https://readdy.ai/api/search-image?query=towel%20radiator%201604x452mm%20anthracite%20finish%20tube%2038x68x12mm%20on%20clean%20white%20background%2C%20modern%20bathroom%20towel%20warmer%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20sleek%20contemporary%20design%2C%20simple%20background&width=600&height=600&seq=afsp&orientation=squarish',
    status: null,
    rating: 4.7,
    reviews: 9,
    description: 'Towel Radiator 1604×452 ø38+68×12 – Anthracite. Slim profile towel radiator with anthracite finish. Efficient heating with a stylish modern look.',
    sizes: ['1604x452'],
    material: 'Steel',
    inStock: true,
    stock: 1,
    itemNo: 'AF-SP',
    pricePerPiece: 3.00,
    costPerPiece: 0.46,
  },
  {
    id: 16,
    name: 'AF-GD – Electric Towel Warmer',
    price: 4.38,
    originalPrice: null,
    category: 'Towel Warmers',
    image: 'https://readdy.ai/api/search-image?query=electric%20towel%20warmer%20600x1000mm%20anthracite%20finish%20on%20clean%20white%20background%2C%20modern%20bathroom%20electric%20towel%20radiator%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20sleek%20contemporary%20design%2C%20simple%20background&width=600&height=600&seq=afgd&orientation=squarish',
    status: 'NEW',
    rating: 4.9,
    reviews: 7,
    description: 'Electric Towel Warmer 600×1000 – Anthracite. Fully electric operation, no plumbing required. Perfect for bathrooms without central heating connections.',
    sizes: ['600x1000'],
    material: 'Steel',
    inStock: true,
    stock: 1,
    itemNo: 'AF-GD',
    pricePerPiece: 3.00,
    costPerPiece: 0.46,
  },
  {
    id: 17,
    name: 'H-VALVE – H Valve Chrome G12',
    price: 4.38,
    originalPrice: null,
    category: 'Valves',
    image: 'https://readdy.ai/api/search-image?query=H%20valve%2016mm%20G12%20chrome%20polished%20finish%20on%20clean%20white%20background%2C%20radiator%20valve%20fitting%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20simple%20background%2C%20plumbing%20accessory&width=600&height=600&seq=hvalve&orientation=squarish',
    status: null,
    rating: 4.6,
    reviews: 29,
    description: 'H-Valve 16MM × G12 – Chrome. Polished chrome finish for a classic look. Compatible with standard radiator systems. Easy installation.',
    sizes: ['Standard'],
    material: 'Chrome Brass',
    inStock: true,
    stock: 5,
    itemNo: 'H-VALVE',
    pricePerPiece: 3.00,
    costPerPiece: 0.46,
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    username: '@sarahm',
    avatar: 'https://i.pravatar.cc/150?img=1',
    review: 'Absolutely love the designer radiator I purchased! The quality is outstanding and it looks stunning in my bathroom. Excellent heat output too.',
  },
  {
    id: 2,
    name: 'James Rodriguez',
    username: '@jamesrod',
    avatar: 'https://i.pravatar.cc/150?img=12',
    review: 'Best online shopping experience for heating products. Fast delivery, professional installation guide, and the flat panel radiator exceeded my expectations.',
  },
  {
    id: 3,
    name: 'Emily Chen',
    username: '@emilyc',
    avatar: 'https://i.pravatar.cc/150?img=5',
    review: 'The towel warmer is absolutely beautiful. Perfect quality and finish. Transformed our bathroom into a warm, luxurious space. Highly recommend!',
  },
  {
    id: 4,
    name: 'Michael Thompson',
    username: '@mikethompson',
    avatar: 'https://i.pravatar.cc/150?img=13',
    review: 'Great selection of radiators and competitive prices. The towel radiator works perfectly and keeps our bathroom warm. Five stars!',
  },
  {
    id: 5,
    name: 'Lisa Anderson',
    username: '@lisaa',
    avatar: 'https://i.pravatar.cc/150?img=9',
    review: 'Impressed with the quality of the heating system. Professional packaging and everything arrived in perfect condition. Installation was straightforward.',
  },
  {
    id: 6,
    name: 'David Park',
    username: '@davidp',
    avatar: 'https://i.pravatar.cc/150?img=14',
    review: 'The electric towel warmer is exactly what we needed. Easy to use, looks modern, and the heat output is perfect every time.',
  },
];
